import React, { useId } from "react";
import "./SwitchField.css";

// Holographic toggle (recolored to the app's #3b82f6 blue + white, sized per
// context via `size`): "sm" for table action-column toggles, "md" (default)
// for standalone filter-bar/form toggles. Keeps the same external contract
// (label/value/onSwitchChange/disabled) every call site already used with
// the old Bootstrap-switch version, so no caller needs to change beyond
// optionally passing `size`.
const SwitchField = ({ label, value, onSwitchChange, disabled, size = "md" }) => {
  const id = useId();

  return (
    <div className={`style_switch holo-switch holo-switch--${size}${disabled ? " is-disabled" : ""}`}>
      {label ? <span className="holo-switch-text">{label}</span> : null}
      <div className="toggle-scale-box">
        <div className="toggle-wrap">
          <input
            className="toggle-input"
            id={id}
            type="checkbox"
            checked={!!value}
            disabled={disabled}
            onChange={onSwitchChange}
          />
          <label className="toggle-track" htmlFor={id}>
            <div className="track-lines">
              <div className="track-line" />
            </div>

            <div className="toggle-thumb">
              <div className="thumb-core" />
              <div className="thumb-inner" />
              <div className="thumb-scan" />
              <div className="thumb-particles">
                <div className="thumb-particle" />
                <div className="thumb-particle" />
                <div className="thumb-particle" />
                <div className="thumb-particle" />
                <div className="thumb-particle" />
              </div>
            </div>

            <div className="toggle-data">
              <div className="data-text off">OFF</div>
              <div className="data-text on">ON</div>
              <div className="status-indicator off" />
              <div className="status-indicator on" />
            </div>

            <div className="energy-rings">
              <div className="energy-ring" />
              <div className="energy-ring" />
              <div className="energy-ring" />
            </div>

            <div className="interface-lines">
              <div className="interface-line" />
              <div className="interface-line" />
              <div className="interface-line" />
              <div className="interface-line" />
              <div className="interface-line" />
              <div className="interface-line" />
            </div>

            <div className="toggle-reflection" />
            <div className="holo-glow" />
          </label>
        </div>
      </div>
    </div>
  );
};

export default SwitchField;
